import initialState from './initialState';
import {
  FETCH_HEROES,
  FETCH_HEROES_DONE,
  FETCH_HEROES_ERROR,
  FETCH_HEROES_LOADING,
  FETCH_HEROES_SUCCESS,
  FETCH_POPINS,
  FETCH_POPINS_DONE,
  FETCH_POPINS_ERROR,
  FETCH_POPINS_LOADING,
  FETCH_POPINS_SUCCESS,
  FETCH_TENANT_STATS,
  FETCH_TENANT_STATS_DONE,
  FETCH_TENANT_STATS_ERROR,
  FETCH_TENANT_STATS_LOADING,
  FETCH_TENANT_STATS_SUCCESS,
  FETCH_USERS,
  FETCH_USERS_DONE,
  FETCH_USERS_ERROR,
  FETCH_USERS_LOADING,
  FETCH_USERS_SUCCESS,
  FETCH_ACTIVITIES_BY_USE_CASE,
  FETCH_ACTIVITIES_BY_USE_CASE_DONE,
  FETCH_ACTIVITIES_BY_USE_CASE_ERROR,
  FETCH_ACTIVITIES_BY_USE_CASE_LOADING,
  FETCH_ACTIVITIES_BY_USE_CASE_SUCCESS
} from '../actions/actionTypes';

// handles Tenant Stats Overview list related actions

const reducerTenantStats = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TENANT_STATS_LOADING:
      return {
        ...state,
        statsLoading: true,
        statsError: null
      };
    case FETCH_TENANT_STATS_SUCCESS:
      return {
        ...state,
        statsOverview: action.allStats.stats,
        statsOverviewPrev: action.allStats.previous_window,
        statsError: null
      };
    case FETCH_TENANT_STATS_ERROR:
      return {
        ...state,
        statsOverview: null,
        statsOverviewPrev: null,
        statsError: action.error
      };
    case FETCH_TENANT_STATS_DONE:
      return {
        ...state,
        statsLoading: null
      };
    default:
      return state;
  }
};

const reducerHeroes = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HEROES_LOADING:
      return {
        ...state,
        heroesLoading: true,
        heroesError: null
      };
    case FETCH_HEROES_SUCCESS:
      return {
        ...state,
        heroes: action.heroesData.heroes,
        heroesTotal: action.heroesData.overview.total_heroes,
        heroesError: null
      };
    case FETCH_HEROES_ERROR:
      return {
        ...state,
        heroes: null,
        heroesTotal: null,
        heroesError: action.error
      };
    case FETCH_HEROES_DONE:
      return {
        ...state,
        heroesLoading: false
      };
    default:
      return state;
  }
};

const reducerUsers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_LOADING:
      return {
        ...state,
        usersLoading: true,
        usersError: null
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.usersData.active_users,
        usersTotal: action.usersData.overview.total_users,
        usersError: null
      };
    case FETCH_USERS_ERROR:
      return {
        ...state,
        users: null,
        usersTotal: null,
        usersError: action.error
      };
    case FETCH_USERS_DONE:
      return {
        ...state,
        usersLoading: null
      };
    default:
      return state;
  }
};

const reducerPopins = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_POPINS_LOADING:
      return {
        ...state,
        popinsLoading: true,
        popinsError: null
      };
    case FETCH_POPINS_SUCCESS:
      // Server delivers back popins broken up, We display active and upcoming all in one
      const active = action.popinsData.popins.active || [];
      const completed = action.popinsData.popins.completed || [];
      const popins = [];
      for (let p of active) {
        popins.push(p);
      }
      for (let p of completed) {
        popins.push(p);
      }
      return {
        ...state,
        popins: popins,
        upcomingPopins: action.popinsData.popins.upcoming || [],
        popinsOverview: action.popinsData.overview,
        popinsError: null
      };
    case FETCH_POPINS_ERROR:
      return {
        ...state,
        popins: null,
        upcomingPopins: null,
        popinsError: action.error
      };
    case FETCH_POPINS_DONE:
      return {
        ...state,
        popinsLoading: false
      };
    default:
      return state;
  }
};

const reducerActivities = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTIVITIES_BY_USE_CASE_LOADING:
      return {
        ...state,
        activitiesLoading: true,
        activitiesError: null
      };
    case FETCH_ACTIVITIES_BY_USE_CASE_SUCCESS:
      return {
        ...state,
        activitiesError: null,
        activities: action.activities.activities,
        activitiesOverview: action.activities.overview
      };
    case FETCH_ACTIVITIES_BY_USE_CASE_ERROR:
      return {
        ...state,
        activitiesError: action.error,
        activities: null,
        activitiesOverview: null
      };
    case FETCH_ACTIVITIES_BY_USE_CASE_DONE:
      return {
        ...state,
        activitiesLoading: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(FETCH_TENANT_STATS)) {
    return reducerTenantStats(state, action);
  } else if (action.type.startsWith(FETCH_HEROES)) {
    return reducerHeroes(state, action);
  } else if (action.type.startsWith(FETCH_USERS)) {
    return reducerUsers(state, action);
  } else if (action.type.startsWith(FETCH_POPINS)) {
    return reducerPopins(state, action);
  } else if (action.type.startsWith(FETCH_ACTIVITIES_BY_USE_CASE)) {
    return reducerActivities(state, action);
  } else {
    return state;
  }
};
